import React, {Component} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import {Link} from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';
import Parser from 'html-react-parser';
import 'moment-timezone';
import Favorite from '../favorite/favorite.component';
import {withRouter} from 'react-router';
import Moment from "react-moment";

class CarouselItem extends Component {

    goTo = (url) => {
        this.props.history.push(url);
    }
    
    render() {
        return (
            <div className="carousel-movie">
                <div className="col-12 image-holder">
                    <img alt={'Film'} src={ API_URL + Parser(this.props.card.film_poster) } />
                    <div className="hitbox" onClick={() => this.goTo(`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`)} />
                </div>
                <div className="col-12 title-holder">
                    <Favorite 
                        favorite={this.props.card.favorite} 
                        component="carousel" 
                        type={this.props.component}
                        id={this.props.card.film_uuid}
                        view={this.props.view}
                    />
                    <span className="title-item">
                    <Link to={`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">    
                        { this.props.card.film_translated_title ? Parser(this.props.card.film_translated_title) : Parser(this.props.card.film_title) }
                    </Link>
                    </span>
                    <span className="year-item">
                        (
                        <Moment format="DD MMMM YYYY" locale="ro" unix>
                            { this.props.card.film_release_date }
                        </Moment>
                        )
                    </span>
                </div>
                <div className="col-12 romanian-translation-title">
                    <span>{ this.props.card.film_title ? Parser(this.props.card.film_title) : '' }</span>
                </div>
                <div className="col-12 movie-dtls">
                    <span className="preview text-capitalize text-white">{ this.props.card.film_status }</span>
                    <span className="genres">Gen: { this.props.card.film_genre }</span>
                </div>
                <div className="col-12 imdb">
                    <span className="imdb-icon"/>
                    <span className="grade">{ this.props.card.film_rating_imdb }</span>
                    <span className="star-icon"/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {})(CarouselItem));





// WEBPACK FOOTER //
// ./src/SHARED/components/carousel/carouselitem.component.js